/**
 * Goal Draft Service — CCA-M3 client
 *
 * Wraps POST /api/v1/goals/draft and POST /api/v1/goals/refine.
 */

import { mutate } from './base-roros.service';

export interface GoalDraftResult {
  title: string;
  qualitative_assessment: string;
  description: string | null;
  draftedByActorId: string;
  draftedByActorName: string;
}

export interface GoalDraftRequest {
  prompt: string;
}

export interface GoalRefineRequest {
  title: string;
  qualitative_assessment: string;
  description?: string | null;
}

export const RorosGoalDraftService = {
  draft: (request: GoalDraftRequest) =>
    mutate<GoalDraftResult | null>('/api/v1/goals/draft', 'POST', request),

  refine: (request: GoalRefineRequest) =>
    mutate<GoalDraftResult | null>('/api/v1/goals/refine', 'POST', request),
};
